import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route, extract } from '@app/core';
import {AccreditedComponent} from '@app/accredited/accredited.component';
import {AccreditedReceiptComponent} from '@app/accredited-receipt/accredited-receipt.component';

const routes: Routes = Route.withShellPublic([
  { path: 'accredited', component: AccreditedComponent, data: {
    title: extract('Central do Lojista - Estabelecimentos') } },
  { path: 'accredited/receipts', component: AccreditedReceiptComponent, data: {
    title: extract('Central do Lojista - Listagem de QR codes') } },
  { path: 'accredited/receipts/:accreditedId', component: AccreditedReceiptComponent, data: {
      title: extract('Central do Lojista - Listagem de QR codes') } }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AccreditedRoutingModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/accredited/accredited-routing.module.ts